<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card my-3 border-0">
                    <div class="card-body">
                        <div class="row">
                            <div class="my-3 d-flex align-items-center">
                                <span class="pointer" routerLink="/user-level">
                                  <svg class="me-3" id="keyboard_backspace_black_24dp_3_" data-name="keyboard_backspace_black_24dp(3)"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path id="Path_7892" data-name="Path 7892" d="M0,0H24V24H0Z" fill="none" />
                                    <path id="Path_7893" data-name="Path 7893" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z"
                                      fill="black" />
                                  </svg>
                                </span>

                                <nav aria-label="breadcrumb">
                                  <ol class="breadcrumb m-0">
                                    <li class="breadcrumb-item fs-18"><a class="text-decoration-none" routerLink="/user-level"
                                        style="color: #949494;">User Role</a></li>
                                    <li class="breadcrumb-item fs-18"><a class="text-decoration-none text-dark fw-500">{{roleId ? 'Edit User Role' : 'Add User Role' }}</a></li>
                                  </ol>
                                </nav>
                              </div>
                                    <form action="">
                                        <div class="row align-items-top">
                                        <div class="col-md-4">
                                            <mat-form-field appearance="outline" class="example-full-width w-100 p-0 mb-1">
                                                <mat-label>Name <span style="color: red;">*</span></mat-label>
                                                <input matInput class="form-control focusNone" type="text" id="name" [(ngModel)]="roleName" placeholder="Enter User Role" appAlphabatesOnly [readonly]="currentMode == 'view'">
                                              </mat-form-field>
                                        </div>
                                        <div class="col-auto ps-0">
                                            <mat-icon role="img" class="mat-icon notranslate material-icons warn-icon customPolicyIconColor" aria-hidden="true" matTooltip="{{allowedMessage}}">info</mat-icon>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                                              <mat-label>User Level <span style="color: red;">*</span></mat-label>
                                              <mat-select  [disabled]="roleId" [(value)]="selectedLevel" placeholder="Select User Level">
                                                <mat-option *ngFor="let userRole of userMasterLevel" [value]="userRole?.id" >
                                                  {{userRole?.name}}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                        </div>
                                    </form>
                                </div>
                            <div class="table-responsive table-bordered">
                            <table class="table">
                                <thead class="bg-light">
                                    <tr class="text-start">
                                        <th class="fw-bold">S.No</th>
                                        <th class="fw-bold">
                                            <span class="d-flex;justify-content-between">
                                                <span class="pe-2">
                                                    <mat-checkbox
                                                    class="customPolicyCheckboxColor"
                                                    [disableRipple]="true"
                                                    (click)="$event.stopPropagation()"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (change)="selectAll($event)"
                                                    [checked]="roleId ? true:false"
                                                    [indeterminate]="isModuleOver(permissionDetails) "
                                                    >
                                                   </mat-checkbox>
                                               </span>
                                               <span>Module </span>
                                            </span>
                                        </th>
                                        <th class="fw-bold">Actions</th>
                                    </tr>
                                </thead>
                                <tbody class="text-start">
                                    <ng-container *ngIf="permissionDetails?.length">
                                        <tr class="text-start" *ngFor="let item of permissionDetails let row=index" >
                                            <td class="text-start">{{row+1}}</td>
                                            <td class="text-start" [ngStyle]="{'pointer-events': currentMode == 'view' ? 'none' : 'auto'}">
                                                <mat-checkbox
                                                class="customPolicyCheckboxColor"
                                                [disableRipple]="true"
                                                [matTooltip]="item?.model"
                                                (click)="$event.stopPropagation()"
                                                [(ngModel)]="item.isAction"
                                                [checked]="isCheckedModule(item)"
                                                [indeterminate]="isIndeterminateModuleOver(item)"
                                                [ngModelOptions]="{ standalone: true }"
                                                (change)="onModuleChange($event, item)"
                                                class="customColorText">
                                                 {{ item?.label ? item?.label : item?.model }}
                                            </mat-checkbox>
                                            </td>
                                            <td class="text-start" [ngStyle]="{'pointer-events': currentMode == 'view' ? 'none' : 'auto'}">
                                                <div class="d-flex flex-wrap">
                                                    <div *ngFor="let actionList of item?.authentication; let i = index">
                                                        <section class="example-section">
                                                        <mat-checkbox
                                                        class="me-3 mb-3 customPolicyCheckboxColor"
                                                        (change)="onActionChange($event, item, actionList)"
                                                        [(ngModel)]="actionList.isAction"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [matTooltip]="actionList?.label"
                                                        >
                                                             {{ actionList?.label ? actionList?.label : actionList?.lebel}}
                                                        </mat-checkbox>
                                                      </section>
                                                    </div>
                                                </div>

                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>

                        <div class="text-end">
                            <button  type="submit" class="btn save-btn rounded-pill text-white" (click)="createRole()" [disabled]="isDisabled()" *ngIf="currentMode != 'view'"><span *ngIf="roleId">Update</span><span *ngIf = "!roleId">Create</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>